const responseCache = new Map();
const inflight = new Map();

const BACKEND_BASE_URL = 'https://shram-images-backend.azurewebsites.net';

export function getBackendUrl(path) {
  return `${BACKEND_BASE_URL}${path}`;
}

// Fix relative API URLs to absolute URLs
export function fixApiUrl(url) {
  if (!url) return url;
  if (url.startsWith('/api/')) {
    return `${BACKEND_BASE_URL}${url}`;
  }
  return url;
}

// Recursively fix API URLs in response objects
function fixApiUrlsInResponse(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(fixApiUrlsInResponse);
  }
  
  const fixed = {};
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string' && (key.includes('Url') || key.includes('url'))) {
      fixed[key] = fixApiUrl(value);
    } else if (typeof value === 'object') {
      fixed[key] = fixApiUrlsInResponse(value);
    } else {
      fixed[key] = value;
    }
  }
  return fixed;
}

export async function api(path, opts = {}) {
  const ttlMs = typeof opts.ttlMs === 'number' ? opts.ttlMs : 300_000;
  const now = Date.now();

  const fullUrl = `${BACKEND_BASE_URL}${path}`;
  const cached = responseCache.get(fullUrl);
  if (cached && cached.expiresAt > now) {
    return cached.value;
  }

  if (inflight.has(fullUrl)) {
    return inflight.get(fullUrl);
  }

  const request = fetch(fullUrl)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then(json => {
      const fixedJson = fixApiUrlsInResponse(json);
      responseCache.set(fullUrl, { value: fixedJson, expiresAt: now + ttlMs });
      inflight.delete(fullUrl);
      return fixedJson;
    })
    .catch(err => {
      inflight.delete(fullUrl);
      throw err;
    });

  inflight.set(fullUrl, request);
  return request;
}

